import instance from "./instance";
import { ENV } from "@/constants/env";
import { ResponseDataDto } from "@/dto/ResponseDto";
import {
  TemplateCategoryMasterCreateRequestDto,
  TemplateCategoryMasterDto,
  TemplateCategoryMasterUpdateRequestDto,
} from "@/dto/TemplateCategoryDto";

// 페이지네이션 응답 인터페이스 정의
export interface PaginatedCategoryResponse {
  list: TemplateCategoryMasterDto[];
  count: number;
  page: number;
  limit: number;
}

// 템플릿 관리 API 경로
const PREFIX_PATH = "admin/template-category";

/**
 * 템플릿 카테고리 마스터 목록 조회
 * @param templateId 템플릿 ID
 * @returns 템플릿 카테고리 마스터 목록 또는 페이지네이션 응답
 */
export const findAll = async (
  templateId?: number
): Promise<TemplateCategoryMasterDto[] | PaginatedCategoryResponse> => {
  // 캐시 방지를 위한 타임스탬프 추가
  const timestamp = new Date().getTime();
  const query = templateId
    ? `?templateId=${templateId}&_t=${timestamp}`
    : `?_t=${timestamp}`;
  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}${query}`);
};

/**
 * 템플릿 카테고리 마스터 생성
 * @param request 템플릿 카테고리 마스터 생성 요청 DTO
 * @returns 템플릿 카테고리 마스터 생성 응답 DTO
 */
export const create = async (
  request: TemplateCategoryMasterCreateRequestDto
): Promise<ResponseDataDto<TemplateCategoryMasterDto>> => {
  return await instance.post(`${ENV.PRE_FIX}/${PREFIX_PATH}`, request);
};

/**
 * 템플릿 카테고리 마스터 수정
 * @param request 템플릿 카테고리 마스터 수정 요청 DTO
 * @returns 템플릿 카테고리 마스터 수정 응답 DTO
 */
export const update = async (
  request: TemplateCategoryMasterUpdateRequestDto
): Promise<ResponseDataDto<TemplateCategoryMasterDto>> => {
  return await instance.put(`${ENV.PRE_FIX}/${PREFIX_PATH}`, request);
};

/**
 * 템플릿 카테고리 마스터 삭제
 * @param id 템플릿 카테고리 마스터 ID
 * @returns 템플릿 카테고리 마스터 삭제 응답 DTO
 */
export const deleteById = async (
  id: string
): Promise<ResponseDataDto<TemplateCategoryMasterDto>> => {
  // API 요구사항에 따라 URL 경로 대신 요청 본문에 ID를 포함
  return await instance.delete(`${ENV.PRE_FIX}/${PREFIX_PATH}`, {
    data: { masterCategoryId: Number(id) },
  });
};
